import React from "react";

// Error Boundary: captura qualquer travamento de renderizacao em qualquer
// tela da aplicacao, evitando que um erro isolado derrube a pagina inteira
// (a "tela toda azul/branca" sem nenhuma explicacao). Em vez disso, mostra
// uma mensagem amigavel com opcao de recarregar ou voltar ao painel.
//
// Tambem grava um pequeno historico dos ultimos erros (com data/hora) no
// localStorage, sob a chave "app_error_log" -- base de dados real para um
// futuro painel de saude/monitoramento, sem precisar de nenhuma infra nova.
function registrarErroLocal(error, info) {
  try {
    const chave = "app_error_log";
    const atual = JSON.parse(localStorage.getItem(chave) || "[]");
    atual.unshift({
      mensagem: String(error?.message || error || "Erro desconhecido"),
      local: info?.componentStack?.split("\n")[1]?.trim() || "",
      quando: new Date().toISOString(),
      url: window.location.pathname + window.location.search,
    });
    localStorage.setItem(chave, JSON.stringify(atual.slice(0, 20)));
  } catch {}
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { temErro: false };
  }

  static getDerivedStateFromError() {
    return { temErro: true };
  }

  componentDidCatch(error, info) {
    console.error("Erro capturado pelo ErrorBoundary:", error, info);
    registrarErroLocal(error, info);
  }

  render() {
    if (this.state.temErro) {
      return (
        <div style={{
          alignItems: "center", background: "var(--bg, #0f1117)", color: "var(--text, #f1f5f9)",
          display: "flex", flexDirection: "column", gap: 16, justifyContent: "center",
          minHeight: "100vh", padding: 24, textAlign: "center",
        }}>
          <div style={{ fontSize: 40 }}>⚠️</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>Algo deu errado nesta tela</div>
          <div style={{ color: "var(--text2, #94a3b8)", fontSize: 14, maxWidth: 420 }}>
            Encontramos um problema inesperado. Voce pode tentar recarregar a pagina,
            ou voltar para o painel principal sem perder seu acesso.
          </div>
          <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
            <button
              onClick={() => window.location.reload()}
              style={{ background: "var(--accent, #2563eb)", border: "none", borderRadius: 8, color: "#fff", cursor: "pointer", fontSize: 14, fontWeight: 600, padding: "10px 20px" }}
            >
              Recarregar pagina
            </button>
            <button
              onClick={() => { window.location.href = "/"; }}
              style={{ background: "transparent", border: "1px solid var(--border, #2a3348)", borderRadius: 8, color: "var(--text2, #94a3b8)", cursor: "pointer", fontSize: 14, padding: "10px 20px" }}
            >
              Voltar ao Painel
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
